import { Component, Inject, LOCALE_ID, OnInit, Pipe, PipeTransform } from '@angular/core';
import { DataService } from 'src/app/core/services/data.service';

@Component({
  selector: 'app-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.scss']
})
export class StatsComponent {
  stat: any = null;
  constructor(@Inject(LOCALE_ID) public locale: string, private dataSrv: DataService) {
    
  }

  ngOnInit(): void {
    this.dataSrv.getStat().subscribe(resp=>{
      this.stat = resp
    })
  }
}

@Pipe({
  name: 'thousandSeparator'
})
export class ThousandSeparatorPipe implements PipeTransform {
  transform(value: number): string {
    if (value === null || value === undefined) {
      return '';
    }

    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }
}
